
import Radio from '@/components/UntitledUI/Radio.vue'
import Icon from '@/components/UntitledUI/Icon.vue'
import Button from '~/components/NewUiElements/Buttons/Button'
import Modal from '~/components/common/Modals/Modal'

export default {
    name: 'DeleteAccount',
    components: { Radio, Button, Modal, Icon },
    data () {
        return {
            checkPasswordForm: new this.$vForm({
                email: '',
                password: '',
                reason: '',
                customReason: ''
            }),
            modalState: {
                isPasswordValid: false,
                isFormContinue: false,
                isDeleteSubmit: false
            },
            customReasonError: '',
            submitted: false,
            deleteReasons: [
                { value: 'do_not_need_qanoniah', label: 'settings delete account reason.do_not_need_qanoniah' },
                { value: 'high_price', label: 'settings delete account reason.high_price' },
                { value: 'unsatisfactory_experience', label: 'settings delete account reason.unsatisfactory_experience' },
                { value: 'not_meeting_needs', label: 'settings delete account reason.not_meeting_needs' },
                { value: 'other', label: 'settings delete account reason.other' }
            ]
        }
    },
    mounted () {
        this.reset()
    },
    methods: {
        checkPassword () {
            this.checkPasswordForm.post('/v1/settings/delete-account')
                .then(() => {
                    this.modalState.isPasswordValid = true
                })
                .catch((e) => {
                    if (e.response?.status !== 422 && e.response?.status !== 403) {
                        throw e
                    }
                    this.checkPasswordForm.errors.set(e.response.data.errors)
                })
        },
        deleteSubmission () {
            this.checkPasswordForm.post('/v1/settings/delete-account')
                .then(() => {
                    this.submitted = true
                })
                .catch((e) => {
                    if (e.response?.status !== 422 && e.response?.status !== 403) {
                        throw e
                    }
                    this.checkPasswordForm.errors.set(e.response.data.errors)
                })
        },
        reset () {
            if (this.submitted) {
                this.$auth.logout()
            }
            this.checkPasswordForm.email = this.$auth.user.email
            this.checkPasswordForm.password = ''
            this.checkPasswordForm.reason = ''
            this.checkPasswordForm.customReason = ''
            this.modalState.isPasswordValid = false
            this.modalState.isFormContinue = false
            this.modalState.isDeleteSubmit = false
            this.customReasonError = ''
        },
        modalStateTrack () {
            if (!this.modalState.isFormContinue) {
                this.modalState.isFormContinue = true
                return
            }
            if (this.modalState.isFormContinue && !this.modalState.isDeleteSubmit) {
                if (this.checkPasswordForm.reason === 'other' && this.checkPasswordForm.customReason === '') {
                    this.customReasonError = this.$t('settings delete account reason.custom_reason_required')
                    return
                }
                this.modalState.isDeleteSubmit = true
                this.deleteSubmission()
            }
        }
    }
}
